class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onContentMouseEnter = this.onContentMouseEnter.bind(this);
    this.onContentMouseLeave = this.onContentMouseLeave.bind(this);
  }

  connectedCallback() {
    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    if (this.content) {
      this.content.addEventListener('mouseenter', this.onContentMouseEnter);
      this.content.addEventListener('mouseleave', this.onContentMouseLeave);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    if (this.content) {
      this.content.removeEventListener('mouseenter', this.onContentMouseEnter);
      this.content.removeEventListener('mouseleave', this.onContentMouseLeave);
    }
  }

  isHoverCapable() {
    return window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  }

  onMouseEnter() {
    if (!this.isHoverCapable() || this.mainDetailsToggle.hasAttribute('open')) return;

    window.clearTimeout(this.closeTimeout);
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    if (!this.isHoverCapable()) return;

    this.scheduleClose();
  }

  onContentMouseEnter() {
    if (!this.isHoverCapable()) return;

    window.clearTimeout(this.closeTimeout);
  }

  onContentMouseLeave() {
    if (!this.isHoverCapable()) return;

    this.scheduleClose();
  }

  scheduleClose() {
    window.clearTimeout(this.closeTimeout);
    this.closeTimeout = window.setTimeout(() => {
      this.close();
    }, 300);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
